
jQuery(document).ready(function() {

  $('.close').on('click', function(){
    $(this).parents('.wrapper-newsletter').css('display','none');
  });

  // HEADER SCROLL

  const header = document.querySelector('header');

  function toggleHeaderClass() {
    header.classList.toggle('scroll', window.scrollY > 0);
  }

  window.addEventListener('scroll', toggleHeaderClass);
  toggleHeaderClass();


  // SLIDERS

  var sliderSettings = {
    infinite: true,
    fade: true,
    arrows: true,
    speed: 0,
    pauseOnFocus: false,
    pauseOnHover: false,
    autoplay: false,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  function revealSlider(event, slick) {
    $(this).css({
      opacity: 1,
      height: 'auto',
      visibility: 'visible'
    });
  }

  // SLIDER ONE
  $('.slider-images-one').on('init', revealSlider);
  if ($('.slider-images-one').length && !$('.slider-images-one').hasClass('slick-initialized')) {
    $('.slider-images-one').slick(sliderSettings);
    setTimeout(function() {
      $('.slider-images-one').slick('slickNext');
      setInterval(function() {
        $('.slider-images-one').slick('slickNext');
      }, 5000);
    }, 2500);
  }

  // SLIDER TWO
  $('.slider-images-two').on('init', revealSlider);
  if ($('.slider-images-two').length && !$('.slider-images-two').hasClass('slick-initialized')) {
    $('.slider-images-two').slick(sliderSettings);
    setTimeout(function() {
      $('.slider-images-two').slick('slickNext');
      setInterval(function() {
        $('.slider-images-two').slick('slickNext');
      }, 5000);
    }, 5000);
  }



  // LISTING SLIDER
  $('.listing-event').slick({
    dots:false,
    infinite: false,
    speed: 300,
    variableWidth: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          variableWidth: true,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          variableWidth: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  // BANNER HOME SCROLL FUNCTION

  function initBannerHomeScroll() {
    var $banner = $('.wrapper-banner-home');
    if (!$banner.length) {
      return;
    }
    function updateBanner() {
      if ($(window).scrollTop() > 10) {
        $banner.addClass('is-hidden');
      } else {
        $banner.removeClass('is-hidden');
      }
    }
    updateBanner();
    $(window).on('scroll', function() {
      updateBanner();
    });
  }

  initBannerHomeScroll();


  // HEADER LOGO

  function initHomeHeaderLogo() {
    var $header = $('.webtimes.is-home header');
    var blurTimer = null;
    var isScrolled = false;

    if (!$header.length) {
      return;
    }

    function clearBlurTimer() {
      if (blurTimer) {
        clearTimeout(blurTimer);
        blurTimer = null;
      }
    }

    function closeMobileMenu() {
      $header.removeClass('is-open');
      $header.find('.nav-toggle').removeClass('is-active');
    }

    function updateHeader() {
      var scrollTop = $(window).scrollTop();

      if (scrollTop > 10) {
        if (!isScrolled) {
          isScrolled = true;
          $header.addClass('scroll');

          clearBlurTimer();

          blurTimer = setTimeout(function() {
            if ($(window).scrollTop() > 10 && isScrolled) {
              $header.addClass('scroll-bg');
            }
          }, 800);
        }
      } else {
        isScrolled = false;
        clearBlurTimer();

        $header.removeClass('scroll-bg');
        $header.removeClass('scroll');

        closeMobileMenu();
      }
    }

    $header.addClass('no-logo-transition');

    updateHeader();

    setTimeout(function() {
      $header.removeClass('no-logo-transition');
    }, 50);

    $(window).on('scroll', updateHeader);
  }

  initHomeHeaderLogo();



  // NAV TOGGLER

  const navToggle = document.querySelector('.nav-toggle');
  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.classList.toggle('is-active');
    header.classList.toggle('is-open');
    navToggle.setAttribute('aria-expanded', isOpen);
    navToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
  });



  // RANDOMISE IMAGE POSITION

  function randomiseListingImagesLoop() {
    var edgePadding = 20;
    var itemGap = 30;
    var maxVisible = 3;

    var revealDelay = 900;
    var swapDelay = 5000;
    var fadeOutDuration = 1200;

    var $listing = $('.listing-images');
    var $items = $listing.find('.item');

    var activeItems = [];
    var shuffledItems = [];
    var currentIndex = 0;

    if (!$listing.length || !$items.length) {
      return;
    }

    function shuffleItems() {
      shuffledItems = $items.toArray();

      for (var i = shuffledItems.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = shuffledItems[i];
        shuffledItems[i] = shuffledItems[j];
        shuffledItems[j] = temp;
      }

      currentIndex = 0;
    }

    function isItemActive($item) {
      return activeItems.some(function($activeItem) {
        return $activeItem[0] === $item[0];
      });
    }

    function getNextHiddenItem($fallbackItem) {
      var attempts = 0;

      while (attempts < shuffledItems.length) {
        if (currentIndex >= shuffledItems.length) {
          shuffleItems();
        }

        var $item = $(shuffledItems[currentIndex]);
        currentIndex++;

        var isVisible = $item.hasClass('is-visible');
        var isHiding = $item.hasClass('is-hiding');
        var isActive = isItemActive($item);

        if (!isVisible && !isHiding && !isActive) {
          return $item;
        }

        attempts++;
      }

      // If all images are in use, safely reuse the one that just faded out
      return $fallbackItem;
    }

    function rectanglesOverlap(rectA, rectB) {
      return !(
        rectA.right < rectB.left ||
        rectA.left > rectB.right ||
        rectA.bottom < rectB.top ||
        rectA.top > rectB.bottom
      );
    }

    function getItemRect($item, left, top) {
      var width = $item.outerWidth();
      var height = $item.outerHeight();

      return {
        left: left - itemGap,
        top: top - itemGap,
        right: left + width + itemGap,
        bottom: top + height + itemGap
      };
    }

    function getActiveRects($excludeItem) {
      var rects = [];

      activeItems.forEach(function($activeItem) {
        if ($excludeItem && $activeItem[0] === $excludeItem[0]) {
          return;
        }

        var left = parseFloat($activeItem.css('left')) || 0;
        var top = parseFloat($activeItem.css('top')) || 0;

        rects.push(getItemRect($activeItem, left, top));
      });

      return rects;
    }

    function randomiseItemPosition($item) {
      var viewportWidth = window.innerWidth;
      var viewportHeight = window.innerHeight;

      var itemWidth = $item.outerWidth();
      var itemHeight = $item.outerHeight();

      var minLeft = edgePadding;
      var minTop = edgePadding;

      var maxLeft = viewportWidth - itemWidth - edgePadding;
      var maxTop = viewportHeight - itemHeight - edgePadding;

      maxLeft = Math.max(minLeft, maxLeft);
      maxTop = Math.max(minTop, maxTop);

      var activeRects = getActiveRects($item);
      var bestLeft = minLeft;
      var bestTop = minTop;
      var foundPosition = false;

      for (var attempt = 0; attempt < 100; attempt++) {
        var randomLeft = Math.floor(Math.random() * (maxLeft - minLeft + 1)) + minLeft;
        var randomTop = Math.floor(Math.random() * (maxTop - minTop + 1)) + minTop;

        var newRect = getItemRect($item, randomLeft, randomTop);

        var overlaps = activeRects.some(function(activeRect) {
          return rectanglesOverlap(newRect, activeRect);
        });

        if (!overlaps) {
          bestLeft = randomLeft;
          bestTop = randomTop;
          foundPosition = true;
          break;
        }
      }

      if (!foundPosition) {
        bestLeft = Math.floor(Math.random() * (maxLeft - minLeft + 1)) + minLeft;
        bestTop = Math.floor(Math.random() * (maxTop - minTop + 1)) + minTop;
      }

      $item.css({
        left: bestLeft + 'px',
        top: bestTop + 'px'
      });
    }

    function revealItem($item) {
      if (!$item || !$item.length) {
        return;
      }

      // Reset while hidden
      $item.removeClass('is-visible is-hiding');

      // Randomise position only while hidden
      randomiseItemPosition($item);

      // Force browser to register hidden state before animating in
      $item[0].offsetHeight;

      setTimeout(function() {
        $item.addClass('is-visible');
        activeItems.push($item);
      }, 30);
    }

    function cycleItems() {
      if (activeItems.length) {
        var $oldestItem = activeItems.shift();

        $oldestItem.removeClass('is-visible').addClass('is-hiding');

        setTimeout(function() {
          $oldestItem.removeClass('is-hiding');

          var $nextItem = getNextHiddenItem($oldestItem);
          revealItem($nextItem);

          setTimeout(cycleItems, swapDelay);
        }, fadeOutDuration);
      } else {
        var $nextItem = getNextHiddenItem();
        revealItem($nextItem);

        setTimeout(cycleItems, swapDelay);
      }
    }

    // Reset
    $items.removeClass('is-visible is-hiding');
    $listing.removeClass('is-front');

    shuffleItems();

    setTimeout(function() {
      $listing.addClass('is-front');
    }, 2200);

    // Initial load, max 4 visible
    var initialCount = Math.min(maxVisible, $items.length);

    for (var i = 0; i < initialCount; i++) {
      setTimeout(function() {
        var $nextItem = getNextHiddenItem();
        revealItem($nextItem);
      }, i * revealDelay);
    }

    // Start continuous loop after first batch is visible
    setTimeout(function() {
      cycleItems();
    }, initialCount * revealDelay + swapDelay);
  }

  $(window).on('load', function() {
    randomiseListingImagesLoop();
  });






});
